import React from "react";
import "./FeedbackItem.css";
import { MdLockOutline } from "react-icons/md";

export default function FeedbackItem(props) {
  const handleSessionClick = () => {
      props.onItemClick();
  };

  return (
    <div
      className={`feedbackItem centeredFlex ${
        (props.index === props.selectedItemIndex) ? "activeFeedbackItem" : ""
      }`}
      style={
        (props.label === "جلسه" && !props.locked && props.filled) ||
        (props.label === "هفته" && props.filled)
          ? { backgroundColor: "var(--green)" }
          : { backgroundColor: "#D9D9D9" }
      }
      onClick={handleSessionClick}
    >
      {props.label === "جلسه" && props.locked && (
        <div className="feedbackItemLockOverlay centeredFlex">
          <MdLockOutline className="feedbackItemLockIcon" />
        </div>
      )}
      <span
        style={
          (props.label === "جلسه" && !props.locked && props.filled) ||
          (props.label === "هفته" && props.filled)
            ? { color: "#FFF" }
            : { color: "#000" }
        }
      >
        {props.label} {props.index + 1}
      </span>
    </div>
  );
}
